import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';

/**
 * Partner Auth0 Provider
 * Partners use the same Auth0 client as regular users (they're just users with partner_admin role)
 */
export default function PartnerAuth0Provider({ children }) {
  const regularClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE || 'https://api.eternavaults.com';

  // Ensure we have a valid origin before constructing redirect URI
  const redirectUri = typeof window !== 'undefined' && window.location.origin 
    ? `${window.location.origin}/auth/callback`
    : '/auth/callback';

  return (
    <Auth0Provider
      domain={domain}
      clientId={regularClientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: audience
      }}
    >
      {children}
    </Auth0Provider>
  );
}

